var map = {
	"./ireland.png": 8687,
	"./logos/Ukrainian community network in Clare.PNG": 1365,
	"./logos/auri.jpg": 9562,
	"./logos/cavan.jpg": 4604,
	"./logos/emerald.png": 9023,
	"./logos/foun.png": 3511,
	"./logos/kalyna.jpg": 8565,
	"./logos/kolo.jpg": 8206,
	"./logos/na.jpg": 600,
	"./logos/newkd.png": 3196,
	"./logos/plast.jpg": 9903,
	"./logos/rlp.jpg": 1353,
	"./logos/ruky.jpg": 4860,
	"./logos/sum.jpg": 1642,
	"./logos/sunflower.jpg": 6764,
	"./logos/together.jpg": 9201,
	"./logos/uact.png": 8712,
	"./logos/uamriya.jpg": 6913,
	"./logos/uaschool.jpg": 9349,
	"./logos/ucci.jpg": 9691,
	"./logos/uculture.jpg": 5678,
	"./logos/uhug.png": 9456,
	"./logos/ulsa.png": 7288,
	"./logos/uvd.jpg": 4460,
	"./logos/uvi.png": 6493,
	"./logos/uvoice.png": 7382,
	"./logos/vira.jpg": 7959,
	"./logos/wwb.jpg": 9843,
	"./onefund.svg": 6081,
	"./uact-logo.png": 4863,
	"./uaemb.jpg": 6736,
	"./ukraine.png": 9017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;